module["exports"] = [
  "###-###"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ko/address/postcode.js
// module id = 1825
// module chunks = 0